export default "__VITE_ASSET__12b92ce1__"